var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 14.5022C29 13.3556 28.253 12.3479 27.1585 12.0091L23.9227 11.0189C20.9519 10.1024 18.8976 8.04808 17.9811 5.07728L16.9909 1.84155C16.6521 0.747042 15.6445 0 14.4978 0C13.3556 0 12.3436 0.747042 12.0091 1.84155L11.0145 5.07728C10.1024 8.04808 8.04373 10.1024 5.07294 11.0189L1.8372 12.0091C0.747042 12.3479 0 13.3556 0 14.5022C0 15.6445 0.747042 16.6564 1.8372 16.9909L5.07728 17.9855C8.04807 18.8976 10.1068 20.9519 11.0189 23.9271L12.0135 27.1628C12.3479 28.253 13.3599 29 14.5022 29C15.6488 29 16.6564 28.253 16.9952 27.1585L17.9855 23.9271C18.9019 20.9519 20.9563 18.8976 23.9271 17.9855L27.1628 16.9909C28.253 16.6564 29 15.6445 29 14.5022ZM14.4978 9.96346C15.6358 11.8311 17.1689 13.3642 19.0365 14.5022C17.1689 15.6358 15.6358 17.1733 14.4978 19.0409C13.3642 17.1733 11.8267 15.6358 9.95911 14.5022C11.8267 13.3642 13.3642 11.8311 14.4978 9.96346Z",
    fill: "url(#paint0_linear_154_2152)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_2152",
    x1: 14.5,
    y1: 0,
    x2: 14.5,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#386641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.4268229c2b89e6c282bd982f20defa7d.svg";
export { ForwardRef as ReactComponent };